var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryFailureOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 35,
    viewBox: "0 0 49 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      filter: "brightness(0) saturate(100%) invert(90%) sepia(15%) saturate(4514%) hue-rotate(300deg) brightness(116%) contrast(100%)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.12109,
    y: 6.14648,
    width: 43.025,
    height: 28.6834,
    fill: "url(#pattern0_7862_4845)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70745 0C3.91835 0 0 3.68786 0 8.19524C0 12.7026 3.91835 16.3905 8.70745 16.3905C13.4965 16.3905 17.4149 12.7026 17.4149 8.19524C17.4149 3.68786 13.4965 0 8.70745 0ZM8.70745 1.82117C10.2071 1.82117 11.6099 2.32199 12.7709 3.09598L3.28948 12.0197C2.46711 10.927 1.93499 9.60665 1.93499 8.19524C1.93499 4.6895 4.98259 1.82117 8.70745 1.82117ZM8.70745 14.5693C7.20783 14.5693 5.80496 14.0685 4.64397 13.2945L14.1254 4.3708C14.9478 5.4635 15.4799 6.78384 15.4799 8.19524C15.4799 11.701 12.4323 14.5693 8.70745 14.5693Z",
    fill: "#959AB3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7862_4845",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7862_4845",
    transform: "matrix(0.0108696 0 0 0.016129 0 -0.290323)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7862_4845",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC9klEQVR4nO2czWpTURDHz8bPvYhaFDXazKQFdSaxK0XER3AniBpn7KKKG6XFbnwEP9C94EJ8AX0Aa3cVfAZFFBW0gl9ETnCZpG1ues+57f8Hh0BKwszvzv3f5N7ehAAAAAAAAAAAAAAAAAAAAAAAACANB05f3E7qN0htkdS/s3pnsy9S+8xqCyR2LfopLHmy1R4jtTepG+OMF4ktjR+/vLfgJEMyr0a4+Fvm81uHEh3jIvW0cIUWid8aUrQtpi6eK7RI7P1QU01q31IXzxVbpHZhzaI3tzD/GaOg0EEOon1l2WK3Q1mknipOuOpieyBa1190aZI3+0QHiHaITj2FjIlOL44RHZ5cKjJaITr5xDEmOr0kRnRUZ42XcY4DX1gc5zq4xLN38cQSzt5p1hspXsB+TWLXa7WZbYgOLUG62FK8wI2M1nJkD5zs1Lsgb6QlNgPRWoZsW4BoXX/R8UI3RGs58QHRCtGd5AcxTLQnF4fo0PRSkdEK0Z3UE4eJ1vSSEB2aXiAyWvNa+MKiEN1JPYWYaE0vDtGh6aUiozUT0SK2k8UesvrXYd7s/w1Gs0db7YMitiU+ktpc1e+4pRH0RepfSPzB2NTNHfFOrMdFiqmfmJZeH2MmmqZVlU0j7is6Diz2o0BRs4Ou9pLYndTSOIO+SH25kOi4Ow0qqCF2OANpndR9dUUXiY6V7hqNl9xTS+M8+noUYlCT2v0Y3Km3PGeyRtVX/OkJUr/XPRiuBlZ72eeN5ga+Tmy+9+v8RciA7PrqF/7x6NvQq83exXgrZtMwjZRFdn3FXYnF//QrKhY8qdOHYrZ1dyux+b7FiP1msf0hA7Lsi9SejiQDxZ+EjMiur9qxS7tI7UPBgj5OnLyyO2REln01xM4M+7mb1JepaadChmTZV138HIt9WusWp6adDRmTZV/dXxITe85qfwcX0v37syNTvi9UgGz7oma7Qep347+osvo7Uv8VH1n8Vff5lnOoILRB+wIAAAAAAAAAAAAII+If51XBQOvpudcAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryFailureOrder);
export default __webpack_public_path__ + "static/media/deliveryFailureOrder.07b59a0f87bdf2a7b79e267b0be62f4c.svg";
export { ForwardRef as ReactComponent };